import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DAOApiService } from '@shared/interfaces';

@Injectable({
  providedIn: 'root',
})
export class ApiService implements DAOApiService {
  private readonly httpClient = inject(HttpClient);

  private readonly defaultHttpParams: HttpParams = new HttpParams();
  private readonly defaultHttpHeaders: HttpHeaders = new HttpHeaders();

  get<T>(
    path: string,
    params: HttpParams = this.defaultHttpParams,
    headers: HttpHeaders = this.defaultHttpHeaders
  ): Observable<T> {
    return this.httpClient.get<T>(path, { headers, params });
  }

  post<T>(
    path: string,
    body: unknown | T = null,
    params: HttpParams = this.defaultHttpParams,
    headers: HttpHeaders = this.defaultHttpHeaders
  ): Observable<T> {
    return this.httpClient.post<T>(path, body, { params, headers });
  }

  put<T>(
    path: string,
    body: unknown | T = null,
    params: HttpParams = this.defaultHttpParams,
    headers: HttpHeaders = this.defaultHttpHeaders
  ): Observable<T> {
    return this.httpClient.put<T>(path, body, { headers, params });
  }

  patch<T>(
    path: string,
    body: unknown | T = null,
    params: HttpParams = this.defaultHttpParams,
    headers: HttpHeaders = this.defaultHttpHeaders
  ): Observable<T> {
    return this.httpClient.patch<T>(path, body, { headers, params });
  }

  delete<T>(
    path: string,
    params: HttpParams = this.defaultHttpParams,
    headers: HttpHeaders = this.defaultHttpHeaders
  ): Observable<T> {
    return this.httpClient.delete<T>(path, { headers, params });
  }
}
